import script from "./BaseDocumentViewer.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseDocumentViewer.vue?vue&type=script&setup=true&lang=js"

import "./BaseDocumentViewer.vue?vue&type=style&index=0&id=6dbaedfe&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\HanYaqoob\\Desktop\\REPOS\\DebtCrmPortalUI\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6dbaedfe"]])

export default __exports__